import * as Yup from 'yup';

const PASSWD_VALIDATION = /^(?=.*[A-Za-z])(?=.*\d).{5,}$/;
const FIRST_NAME_VALIDATION = /^[\p{L} ,.'-]{3,40}$/u;
const LAST_NAME_VALIDATION = /^[\p{L} ,.'-]{2,40}$/u;
const FIRST_NAME_ERROR_COPY =
  "Gunakan huruf, spasi, dan hanya simbol berikut: (') (,) (.) (-)";
const LAST_NAME_ERROR_COPY =
  "Gunakan huruf, spasi, dan hanya simbol berikut: (') (,) (.) (-)";
const COMPANY_NAME_VALIDATION = /^[-\p{L}0-9 ,.'()]{3,}$/u;
const COMPANY_NAME_ERROR_COPY =
  "Gunakan huruf, angka, spasi, dan hanya simbol berikut: (') (,) (.) (-)";

export const RegisterValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Format email yang Anda masukkan salah')
    .required('Email harus diisi')
    .label('Email'),
  first_name: Yup.string()
    .required('Nama Depan harus diisi')
    .trim('Masukkan Nama Depan yang valid')
    .strict(true)
    .max(40, FIRST_NAME_ERROR_COPY)
    .matches(FIRST_NAME_VALIDATION, FIRST_NAME_ERROR_COPY)
    .label('Nama Depan'),
  last_name: Yup.string()
    .trim('Masukkan Nama Belakang yang valid')
    .strict(true)
    .max(40, LAST_NAME_ERROR_COPY)
    .test('valid-last-name', LAST_NAME_ERROR_COPY, (value) => {
      if (!value) return true;
      return LAST_NAME_VALIDATION.test(value);
    })
    .label('Nama Belakang'),
  password: Yup.string()
    .required('Kata Sandi harus diisi')
    .label('Kata Sandi')
    .min(5, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka'),
  confirm_password: Yup.string()
    .required('Konfirmasi Kata Sandi harus diisi')
    .oneOf(
      [Yup.ref('password')],
      'Kata sandi harus sama dengan konfirmasi kata sandi'
    )
    .label('Konfirmasi Kata Sandi')
    .min(5, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka'),
  customer_code: Yup.string()
    .required('Kode Customer harus diisi')
    .trim('Masukkan Kode Customer yang valid')
    .strict(true)
    .label('Kode Bill To Customer'),
  company_name: Yup.string()
    .required('Nama Perusahaan harus diisi')
    .trim('Masukkan Nama Perusahaan yang valid')
    .strict(true)
    .min(3, 'Nama Perusahaan minimal 3 karakter')
    .matches(COMPANY_NAME_VALIDATION, COMPANY_NAME_ERROR_COPY)
    .label('Nama Perusahaan'),
});

export const LoginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Format email yang Anda masukkan salah')
    .required('Email harus diisi')
    .label('Email'),
  password: Yup.string().required('Kata sandi harus diisi').label('Password'),
});

export const ForgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Format email yang Anda masukkan salah')
    .required('Email harus diisi')
    .label('Email'),
});

export const ResetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Kata sandi baru harus diisi')
    .min(5, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .label('Kata Sandi'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Kata sandi tidak sesuai')
    .required('Konfirmasi kata sandi baru harus diisi')
    .min(5, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .label('Konfirmasi Kata Sandi'),
});

export const ChangePasswordValidationSchema = Yup.object().shape({
  old_password: Yup.string()
    .required('Kata sandi sekarang harus diisi')
    .label('Kata Sandi'),
  new_password: Yup.string()
    .required('Kata sandi baru harus diisi')
    .min(5, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .label('Kata Sandi Baru'),
  confirm_new_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], 'Kata sandi tidak sesuai')
    .min(5, 'Kata Sandi minimal 5 Karakter')
    .required('Konfirmasi kata sandi baru harus diisi')
    .oneOf(
      [Yup.ref('new_password')],
      'Konfirmasi kata sandi baru harus sesuai dengan kata sandi baru'
    )
    .matches(PASSWD_VALIDATION, 'Kata Sandi minimal 5 karakter dan 1 angka')
    .label('Konfirmasi Kata Sandi'),
});

export const EmailPemulihanValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Format email yang Anda masukkan salah')
    .required('Email harus diisi')
    .label('Email'),
});
